import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import CartItemEntity from '../../domain/entities/Cart/CartItem';
import { CartItemImage } from '../CartItems/common';
import GiftWrapController from '../../controllers/GiftWrapViewController';
import { diContainer, serviceNames } from '../../diContainer/diContainer';
import { CollapsedCartItemSkeleton } from '../CartItems/CartItemSkeleton';

const ImagesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

const ImageContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 20%;
`;

const Overlay = styled.div`
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.32);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ItemCount = styled.p`
  font-size: 16px;
  font-weight: 500;
  margin: 16px 0;
  text-align: center;
  color: #ffffff;
`;

interface ICollapsedShoppingBagProps {
  cartItems: CartItemEntity[];
  baseUrl: string;
  toggleShoppingBagOpen?(e: React.SyntheticEvent): void;
}

@observer
class CollapsedShoppingBag extends React.Component<ICollapsedShoppingBagProps> {
  private readonly ctrl: GiftWrapController;

  constructor(props: ICollapsedShoppingBagProps) {
    super(props);
    this.ctrl = diContainer.get(serviceNames.giftWrapController);
  }

  render(): JSX.Element {
    const {
      data: {
        isGWImageHiddenInShoppingBag,
      },
    } = this.ctrl;

    const {
      cartItems,
      baseUrl,
      toggleShoppingBagOpen,
    } = this.props;

    if (cartItems && cartItems.length) {
      return (
        <ImagesWrapper
        onClick={toggleShoppingBagOpen}
        className="acac-shopping-bag-toggle-btn"
        aria-expanded
        >
          {cartItems.slice(0, 4).map((item, index) => (
            <React.Fragment key={item.skuBaseId}>
              {!(isGWImageHiddenInShoppingBag && item.skuType === 'GW') && (
                <ImageContainer>
                  <CartItemImage baseUrl={baseUrl} item={item} />
                  {index === 3 && this.props.cartItems.length > 4 && (
                    <Overlay>
                      <ItemCount>+{this.props.cartItems.length - 3}</ItemCount>
                    </Overlay>
                  )}
                </ImageContainer>
              )}
            </React.Fragment>
          ))}
        </ImagesWrapper>
      );
    }

    return (
      <ImagesWrapper>
        <CollapsedCartItemSkeleton />
        <CollapsedCartItemSkeleton />
        <CollapsedCartItemSkeleton />
      </ImagesWrapper>
    );
  }
}

export default CollapsedShoppingBag;
